import React, { useState, useEffect } from 'react';
import ProgramsReport from '../reporting/ProgramsReport';
import VolunteersReport from '../reporting/VolunteersReport';
import ServiceHoursReport from '../reporting/ServiceHoursReport';

function ReportingModal({ isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState('programs');

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const tabs = [
    {
      id: 'programs',
      label: 'Programs',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
        </svg>
      )
    },
    {
      id: 'volunteers',
      label: 'Volunteers',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
        </svg>
      )
    },
    {
      id: 'serviceHours',
      label: 'Service Hours',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
      )
    }
  ];

  return (
    // <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 animate-in fade-in duration-500">
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50 animate-in fade-in duration-500 flex items-center justify-center p-4">
      {/* <div className="relative mx-auto p-6 border w-full max-w-6xl shadow-2xl rounded-lg bg-white my-10 animate-in slide-in-from-bottom duration-700"> */}
      <div className="relative mx-auto border w-full max-w-6xl shadow-2xl rounded-lg bg-white max-h-[90vh] flex flex-col animate-in slide-in-from-bottom duration-700">
        {/* Header */}
        {/* <div className="flex justify-between items-center mb-6 animate-in slide-in-from-top duration-500 delay-200"> */}
        <div className="flex justify-between items-center p-6 border-b flex-shrink-0 animate-in slide-in-from-top duration-500 delay-200">
          <h3 className="text-xl font-medium text-gray-900">Reporting</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl transition-all duration-300 transform hover:scale-125 hover:rotate-90 active:scale-95"
          >
            ×
          </button>
        </div>

        {/* Tabs */}
        {/* <div className="border-b border-gray-200 mb-6"> */}
        <div className="border-b border-gray-200 px-6 flex-shrink-0">
          <div className="flex">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium transition-colors ${activeTab === tab.id
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-500 hover:text-gray-700'
                  }`}
              >
                <div
                  className="p-1 rounded-full"
                  style={{ backgroundColor: '#DBEAFE' }}
                >
                  <div style={{ color: '#2563EB' }}>
                    {tab.icon}
                  </div>
                </div>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* <div className="space-y-6"> */}
        <div className="flex-1 overflow-y-auto p-6">
          {activeTab === 'programs' && (
            <ProgramsReport />
          )}

          {activeTab === 'volunteers' && (
            <VolunteersReport />
          )}

          {activeTab === 'serviceHours' && (
            <ServiceHoursReport />
          )}
        </div>
      </div>
    </div>
  );
}

export default ReportingModal;